import React, { PureComponent } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Container, InnerContainer } from './styles';

// import LiveEventsList from './LiveEventsList/component';
import { IProps } from './interfaces';
import { IState } from '../../state/search';
import { Routes as AppRoutes } from '../../constants';
import AdminDashboard from './AdminDashboard/component';

class AdminDashboardContainer extends PureComponent<IProps, IState> {
  render() {
    return (
      <Container>
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to={AppRoutes.ADMIN_DASHBOARD} replace />} />
        </Routes>
      </Container>
    );
  }
}

export default AdminDashboardContainer;
